import { UPDATE_DP_FOOTNOTE_DATA } from "src/DigitalProtocolModule/constants";

interface FootnoteData {
  footnoteDataList: DPFootnote.FootnoteData[]
}

const initialFootnoteData: FootnoteData = {
  footnoteDataList: [],
};

const dpFootnoteDataReducer = (state = initialFootnoteData, action) => {
  switch (action.type) {
    case UPDATE_DP_FOOTNOTE_DATA:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    default:
  }
  return state;
};
export default dpFootnoteDataReducer;
